import MuiTable from '@mui/material/Table';
import MuiTableBody from '@mui/material/TableBody';
import MuiTableCell from '@mui/material/TableCell';
import MuiTableContainer from '@mui/material/TableContainer';
import MuiTableFooter from '@mui/material/TableFooter';
import MuiTableHead from '@mui/material/TableHead';
import { css } from '@src/common/styles/Styles';
import { theme } from '@src/common/styles/Theme';
import type { ComponentProps } from 'react';

type Props = {
  maxHeight?: number | string;
} & ComponentProps<typeof MuiTable>;

export const Table = ({ maxHeight, ...props }: Props) => {
  return (
    <MuiTableContainer sx={{ maxHeight }}>
      <MuiTable {...props} />
    </MuiTableContainer>
  );
};

export const TableHead = (props: ComponentProps<typeof MuiTableHead>) => {
  return <MuiTableHead className={tableHead} {...props} />;
};

export const TableBody = (props: ComponentProps<typeof MuiTableBody>) => {
  return <MuiTableBody {...props} />;
};

export const TableCell = (props: ComponentProps<typeof MuiTableCell>) => {
  return <MuiTableCell {...props} />;
};

export const TableFooter = (props: ComponentProps<typeof MuiTableFooter>) => {
  return <MuiTableFooter {...props} />;
};

const tableHead = css({
  backgroundColor: theme.palette.surface.surface,
});
